// (function () {
//     'use strict';

//     angular.module("imApp").factory("custProdAccBcsService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getCustProdAccBcs: function (parms) {
//                 return $ihttp.post({
//                     method: 2994,
//                     parameters: parms || {}
//                 });
//             },
//             saveGrid: function (mergeObj) {
//                 return $ihttp.post({
//                     method: 2999,
//                     parameters: mergeObj
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
